import { ResponsiveBar } from '@nivo/bar'
import { useMemo } from 'react'
import { getBarChartParams } from '../../components/customCharts/helpers'
import { CustomChart as CustomChartType } from '../../components/customCharts/types'
import { theme } from '../../constants'

export const CustomBarChart = ({
  chart,
  data,
}: {
  chart: CustomChartType
  data: any
}) => {
  const params = useMemo(() => getBarChartParams(chart, data), [chart, data])

  return (
    // @ts-ignore
    <ResponsiveBar
      {...params}
      theme={theme}
      layout="vertical"
      enableLabel={false}
      enableGridX={false}
      enableGridY
      borderRadius={3}
      padding={0.1}
      borderWidth={1.1}
      borderColor={{
        from: 'color',
        modifiers: [['darker', 0.3]],
      }}
      axisTop={null}
      axisRight={null}
    />
  )
}
